import { useLayoutEffect, useState } from 'react';

type WindowSize = {
	width: number;
	height: number;
};

function getWindowSize(): WindowSize {
	const width = window.innerWidth;
	const height = window.innerHeight;
	return { width, height };
}

export function useWindowSize(options?: { debounce?: number; onChange?: (newSize: WindowSize) => void }) {
	const [size, setSize] = useState<WindowSize>({ width: 0, height: 0 });

	const debounceMs = options?.debounce || 250;
	useLayoutEffect(() => {
		let timeoutId: ReturnType<typeof setTimeout>;
		const update = () => {
			setSize(getWindowSize());
		};
		const handleResize = () => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				update();
				options?.onChange?.(getWindowSize());
			}, debounceMs);
		};
		update();
		window.addEventListener('resize', handleResize);
		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('resize', handleResize);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return size;
}
